import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiQueryHook } from '../../../common/queryClient/createApiQueryHook';
import { AlgorithmUrl } from './AlgorithmUrl';
import { AlgorithmExtendedType } from '../schema/types';
import { AlgorithmExtendedSchema } from '../schema/AlgorithmExtendedSchema';

interface AlgorithmsByIdsQueryParams {
  algorithmIds: number[];
}

const getAlgorithmsByIds = (params?: AlgorithmsByIdsQueryParams) =>
  apiClient
    .get<AlgorithmExtendedType[]>(expand(AlgorithmUrl.BY_IDS, params))
    .then((response) => AlgorithmExtendedSchema.array().parse(response.data));

export const useListAlgorithmsByIdsQuery = createApiQueryHook(
  ['algorithms-by-ids'],
  getAlgorithmsByIds
);
